import { Skeleton } from '@mui/material';

export default function AdditionalInfoSkeleton() {
    return (
        <div
            style={{
                height: 'calc(-64px + 100svh)',
                overflowY: 'auto',
                paddingTop: '15px',
                paddingBottom: '60px',
            }}
        >
            <div className="flex flex-col px-5">

                {/* Loan Template Card */}
                <Skeleton
                    variant="rectangular"
                    height={120}
                    sx={{ borderRadius: 2, mb: 3 }}
                />

                {/* Description text */}
                <Skeleton width="90%" height={20} sx={{ mb: 1 }} />
                <Skeleton width="80%" height={20} sx={{ mb: 3 }} />

                {/* CardLine */}
                <Skeleton
                    variant="rectangular"
                    height={90}
                    sx={{ borderRadius: 2, mb: 4 }}
                />

                {/* Section title */}
                <Skeleton width="60%" height={24} sx={{ mb: 2 }} />

                {/* Calculation box */}
                <div className="bg-[var(--input-bg-color)] p-4 rounded-lg mb-5 border border-[var(--border-color)]">
                    <div className="flex flex-col gap-[15px]">
                        {Array.from({ length: 4 }).map((_, index) => (
                            <div
                                key={index}
                                className="flex justify-between items-center"
                            >
                                <Skeleton width={120} height={18} />
                                <Skeleton width={100} height={18} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* HTML terms content */}
                <Skeleton width="100%" height={18} sx={{ mb: 1 }} />
                <Skeleton width="100%" height={18} sx={{ mb: 1 }} />
                <Skeleton width="90%" height={18} sx={{ mb: 4 }} />

                {/* Checkbox */}
                <div className="flex items-center mb-5">
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton width="80%" height={20} sx={{ ml: 2 }} />
                </div>

                {/* Button */}
                <Skeleton
                    variant="rectangular"
                    height={48}
                    sx={{ borderRadius: 2 }}
                />

            </div>
        </div>
    );
}
